export default function currencyFormat(value) {
  return new Intl.NumberFormat("en", {
    maximumFractionDigits: value <= 1000000 ? 0 : 1,
    notation: "compact",
    currency: "USD",
    style: "currency",
  }).format(value);
}
